<template>
	<div>
		<CModal title="Ajouter un client" size="lg" :show.sync="showModal">
			<form ref="mainForm" action="/api/users" method="post" axiosMethod="post">
				<CRow>
					<CCol sm="6">
						<CInput type="email" label="E-mail" name="email" required />
					</CCol>
				</CRow>
				<CRow>
					<CCol sm="6">
						<CInput type="password" label="Mot de passe" name="password" required />
					</CCol>
				</CRow>
			</form>

			<template #footer>
				<CButton color="secondary" v-on:click="showModal = false">Annuler</CButton>
				<CButton color="success" v-on:click="onSubmit($refs.mainForm)">Ajouter</CButton>
			</template>
		</CModal>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				showModal: false,
			};
		},

		methods: {
			onSubmit: function (form) {
				this.$formDataToApi.sendForm(form).then(res => {
					if (res.status === 200 || res.status === 201) {
						this.$toast.success('Nouveau client créé avec succès !');
						this.showModal = false;
						this.$emit('refresh');
					} else {
						this.$toast.error(res.data['hydra:description']);
					}
				});
			},
		},
	};
</script>
